module.exports = __webpack_public_path__ + "img/ladies_inquiry.12785fa2.png";